import GSAP from 'gsap'

import Experience from '../Experience'

export default class Events {
  constructor() {
    //setup
    this.experience = new Experience()
    this.camera = this.experience.camera
    this.scene = this.experience.scene
    this.world = this.experience.world
    this.hell = this.experience.world.hell
    this.tL = new GSAP.timeline()

    //audio
    this.audio = document.querySelector('audio')
    this.audio.volume = 0.5

    //options
    this.loader = document.querySelector('.loader')
    this.title = document.querySelector('h1')
    this.description = document.querySelector('main p')
    this.audioBtn = document.querySelector('.control > li')
    this.audioText = document.querySelector('.control > li p')
    this.audioImg = document.querySelector('.control > li img')
    this.control = document.querySelector('.control')
    this.closeLoader()
    this.audioControl()
  }
  closeLoader() {
    this.loader.addEventListener('click', () => {
      this.audio.play()
      this.tL
        .to(this.loader, { autoAlpha: 0, ease: 'linear' })
        .from(this.control, { autoAlpha: 0, xPercent: 10 })
        .from(this.title, { autoAlpha: 0, y: 10 })
        .from(this.description, { autoAlpha: 0, y: 10 })
    })
  }
  audioControl() {
    this.audioBtn.addEventListener('click', () => {
      if (this.audio.paused) {
        this.audio.play()
        this.audio.loop = true
        this.audioText.style.textDecoration = 'none'
        this.audioImg.style.animation = 'playing 1s infinite linear'
      } else {
        this.audio.pause()
        this.audioText.style.textDecoration = 'line-through'
        this.audioImg.style.animation = 'none'
      }
    })
  }
}
